import AdminLayout from '@/views/admin/AdminLayout.vue'
import Dashboard from '@/views/admin/Dashboard.vue'
import AdminLogin from '@/views/admin/AdminLogin.vue'
import Profile from '@/views/admin/Profile.vue'
import UserQuery from '@/views/admin/UserQuery.vue'
import ImageStats from '@/views/admin/ImageStats.vue'
import '@fortawesome/fontawesome-free/css/all.css'
// 统计分析
import DownloadStats from '@/views/admin/usage/DownloadStats.vue'
import UserGrowthStats from '@/views/admin/usage/UserGrowthStats.vue'
import ActiveUserStats from '@/views/admin/usage/ActiveUserStats.vue'
import UsageTimeStats from '@/views/admin/usage/UsageTimeStats.vue'
import UserInfoStats from '@/views/admin/usage/UserInfoStats.vue'

// 用户管理
import UserList from '@/views/admin/users/UserList.vue'
import UserAudit from '@/views/admin/users/UserAudit.vue'
import UserFeedback from '@/views/admin/users/UserFeedback.vue'

// 内容管理
import CaseManage from '@/views/admin/content/CaseManage.vue'
import TutorialManage from '@/views/admin/content/TutorialManage.vue'
import VersionManage from '@/views/admin/content/VersionManage.vue'
import NewManage from '@/views/admin/content/NewManage.vue'
// 系统设置
import SystemSettings from '@/views/admin/settings/SystemSettings.vue'
import QrcodeUpload from '@/views/admin/QrcodeUpload.vue'

const adminRoutes = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: {
      requiresAuth: false,
      adminAccess: false
    }
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    meta: {
      requiresAuth: true,
      adminAccess: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: Dashboard,
        meta: {
          title: '仪表盘',
          icon: 'DataLine'
        }
      },
      {
        path: 'userquery',
        name: 'UserQuery',
        component: () => import('@/views/admin/UserQuery.vue'), // 使用异步组件
        meta: { 
          title: '使用时长查询',
          permissions: ['admin:view']
        }
      },
      {
        path: 'image-stats',
        name: 'ImageStats',
        component: () => import('@/views/admin/ImageStats.vue'), // 使用异步组件: ImageStats,
        meta: {
          title: '影像信息统计',
          icon: 'Picture',
          permissions: ['admin:view']
        }
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: Profile,
        meta: {
          title: '个人信息',
          icon: 'User'
        }
      },
      {
        path: 'stats',
        name: 'AdminStats',
        redirect: '/admin/stats/download',
        meta: {
          title: '统计分析',
          icon: 'TrendCharts'
        },
        children: [
          {
            path: 'download',
            name: 'DownloadStats',
            component: DownloadStats,
            meta: {
              title: '下载趋势',
              icon: 'Download'
            }
          },
          {
            path: 'user-growth',
            name: 'UserGrowthStats',
            component: UserGrowthStats,
            meta: {
              title: '用户增长',
              icon: 'User'
            }
          },
          {
            path: 'active-users',
            name: 'ActiveUserStats',
            component: ActiveUserStats,
            meta: {
              title: '活跃用户',
              icon: 'UserFilled'
            }
          },
          {
            path: 'usage-time',
            name: 'UsageTimeStats',
            component: UsageTimeStats,
            meta: {
              title: '使用时长',
              icon: 'Timer'
            }
          },
          {
            path: 'user-info',
            name: 'UserInfoStats',
            component: UserInfoStats,
            meta: {
              title: '用户信息',
              icon: 'Monitor'
            }
          }
        ]
      },
      {
        path: 'users',
        name: 'AdminUsers',
        redirect: '/admin/users/list',
        meta: {
          title: '用户管理',
          icon: 'UserFilled'
        },
        children: [
          {
            path: 'list',
            name: 'UserList',
            component: UserList,
            meta: {
              title: '用户列表',
              icon: 'List'
            }
          },
          {
            path: 'audit',
            name: 'UserAudit',
            component: UserAudit,
            meta: {
              title: '用户审核',
              icon: 'Check'
            }
          },
          {
            path: 'feedback',
            name: 'UserFeedback',
            component: UserFeedback,
            meta: {
              title: '用户反馈',
              icon: 'ChatDotRound'
            }
          }
        ]
      },
      {
        path: 'content',
        name: 'AdminContent',
        redirect: '/admin/content/case',
        meta: {
          title: '内容管理',
          icon: 'Document'
        },
        children: [
          {
            path: 'case',
            name: 'CaseManage',
            component: CaseManage,
            meta: {
              title: '案例管理',
              icon: 'Collection'
            }
          },
          {
            path: 'tutorial',
            name: 'TutorialManage',
            component: TutorialManage,
            meta: {
              title: '教程管理',
              icon: 'Reading'
            }
          },
          {
            path: 'version',
            name: 'VersionManage',
            component: VersionManage,
            meta: {
              title: '版本管理',
              icon: 'Download'
            }
          },
          {
            path: 'new',
            name: 'NewManage',
            component: NewManage,
            meta: {
              title: '新闻管理',
              icon: 'News'
            }
          }
        ]
      },
      {
        path: 'qrcode',
        name: 'QrcodeUpload',
        component: QrcodeUpload,
        meta: {
          title: '入群二维码',
          icon: 'PictureFilled'
        }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: SystemSettings,
        meta: {
          title: '系统设置',
          icon: 'Setting'
        }
      }
    ]
  }
]

export default adminRoutes 